import { render, staticRenderFns } from "./partner-owner-form.vue?vue&type=template&id=4d37dfd2"
import script from "./partner-owner-form.vue?vue&type=script&lang=js"
export * from "./partner-owner-form.vue?vue&type=script&lang=js"
import style0 from "./partner-owner-form.vue?vue&type=style&index=0&id=4d37dfd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports